import React, { createContext, useState, useContext } from 'react';

const UserRoleContext = createContext(null);

export const UserRoleProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [permissions, setPermissions] = useState({});


    // * From ss rights remove .aspx which is used on the old SS 
    const stripAspx = (key) => key.replace('.aspx', '');
    const loadPermissions = (roleData) => {
        const parseRole = (raw) => {
            if (!raw) return [];
            const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
            return parsed.map(task => ({
                ...task,
                taskOptions: task.taskOptions
                    ? Object.entries(typeof task.taskOptions === 'string'
                        ? JSON.parse(task.taskOptions)
                        : task.taskOptions
                    ).reduce((acc, [key, value]) => {
                        acc[stripAspx(key)] = {
                            ...value,
                            mnuOption: stripAspx(value.mnuOption),
                        };
                        return acc;
                    }, {})
                    : {},
            }));
        };

        setPermissions({
            hr: parseRole(roleData.hr),
            ss: parseRole(roleData.ss),
            admin: parseRole(roleData.admin),
        });
    };
    // console.log(permissions.ss)
    // console.log(permissions.hr)
    const hasAccess = (taskOrOption, table = 'ss', requireCRUD = false) => {
        //* Admin bypass
        const adminTask = permissions.admin?.find(t => t.task === 'Admin');
        if (adminTask?.accessLevel === 'CRUD') return true;

        const allTasks = table === 'ss' ? [
            ...(permissions.ss || []),
        ] : [
            ...(permissions.hr || []),
        ];

        //* Check direct task match first
        let found = allTasks.find(t => t.task === taskOrOption);
        let accessLevel;


        if (found) {
            accessLevel = found.accessLevel;
        } else {
            //* Check taskOptions keys 
            const parentTask = allTasks.find(t =>
                t.taskOptions && t.taskOptions[taskOrOption] !== undefined
            );
            if (parentTask) {
                //* taskOptions inherit parent accessLevel, adding this here in case we do accesslevel per taskOption at some point in the future
                accessLevel = parentTask.taskOptions[taskOrOption].accessLevel || parentTask.accessLevel;
            }
        }

        if (!accessLevel && accessLevel !== '') return false;
        if (requireCRUD) return accessLevel === 'CRUD';
        return true;
    };

    const hasOptionAccess = (parentTask, optionKey, table = 'ss', requireCRUD = false) => {
        //* Admin bypass
        const adminTask = permissions.admin?.find(t => t.task === 'Admin');
        if (adminTask?.accessLevel === 'CRUD') return true;
        const allTasks = table === 'ss' ? [
            ...(permissions.ss || []),
        ] : [
            ...(permissions.hr || []),
        ];
        const parent = allTasks.find(t => t.task === parentTask);
        if (!parent) return false;

        const option = parent.taskOptions?.[optionKey];
        if (!option) return false;

        if (requireCRUD) return option.accessLevel === 'CRUD';
        return true;
    };

    const getTaskMenuOptions = (taskName, specificTable = 'hr') => {
        const allTasks = specificTable === 'hr'
            ? [...(permissions.hr || [])]
            : [...(permissions.ss || [])];

        const task = allTasks.find(t => t.task === taskName);
        if (!task?.taskOptions) return [];

        return Object.values(task.taskOptions).map(opt => opt.mnuOption);
    };
    return (
        <UserRoleContext.Provider value={{ user, setUser, loadPermissions, hasAccess, hasOptionAccess, getTaskMenuOptions, permissions }}>
            {children}
        </UserRoleContext.Provider>
    );
};

export const useUserRole = () => useContext(UserRoleContext);
export default UserRoleContext;